import React, { useEffect, useState } from 'react';
import { fetchTransactions } from '../../../../../actions/datasource';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Icon, Container } from 'semantic-ui-react';
import _ from "lodash";
import cx from "classnames";
import moment from "moment";
import { Image } from 'react-bootstrap';
import GoogleDriveIcon from "../../../../../images/datasources/gdrive.png"
import DropboxIcon from "../../../../../images/datasources/dropbox.png"
import OnedriveIcon from "../../../../../images/datasources/onedrive.png"
import SharepointIcon from "../../../../../images/datasources/sharepoint.png"
import BoxIcon from "../../../../../images/datasources/box.png"
import RssFeedIcon from "../../../../../images/datasources/rss.png"

import InfiniteScroll from "components/ui/InfiniteScroll";

import styles from "./transactions.module.scss";

export default function DataSourceTransactions({ account }) {

  const dispatch = useDispatch();

  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(20);

  const { loading, items, pagination } = useSelector((state) => _.get(state, "datasources.transactions"));

  const currentPage = useSelector((state) =>
    _.get(state, "datasources.transactions.pagination.currentPage")
  );

  const totalPages = useSelector((state) =>
    _.get(state, "datasources.transactions.pagination.totalPages")
  );

  const totalRecordsCount = useSelector((state) =>
    _.get(state, "datasources.transactions.pagination.totalRecordsCount")
  );

  useEffect(() => {
    dispatch(fetchTransactions({ page: page, limit: limit, filters: { accountId: account.id, refresh: true } }));
  }, [page]);


  const noDataMessage = () => {
    return <>
      <Table.Row>
        <Table.Cell colSpan="5" className={cx(styles.cell)}>
          <div className={cx(styles.noData)}>
            No Datasource Mapping Transactions
          </div>
        </Table.Cell>
      </Table.Row>
    </>
  }

  const loadingMessage = () => {
    return <>
      <Table.Row>
        <Table.Cell colSpan="5" className={cx(styles.cell)}>
          <div className={cx(styles.noData)}>
            Loading
            <Icon name="sync" loading className={cx(styles.icon)} />
          </div>
        </Table.Cell>
      </Table.Row>
    </>
  }

  const renderTransactions = () => {
    return <> {items && items.length > 0 && items.map((item, idx) => renderTransaction({ item, idx }))} </>
  }

  const showIcon = (storageType) => {
    
    switch(storageType) {
      case "gdrive":
        return GoogleDriveIcon;
      case "dropbox":
        return DropboxIcon;
      case "onedrive":
        return OnedriveIcon;
      case "box":
        return BoxIcon;
      case "sharepoint":
        return SharepointIcon;
      case "rss":
        return RssFeedIcon;

      default:
    }
    return null;
  }

  const renderTransaction = ({ item, idx }) => {
    console.log(item)
    return <>
      <Table.Row key={idx}>
        <Table.Cell width={2} className={cx(styles.cell)}>
          <div className={cx(styles.text)}> {item.folder} </div>
          <div className={cx(styles.datasourceName)}>
            {item.storageType && <Image src={showIcon(item.storageType)} className={cx(styles.iconDS)} />}
           <div className= {cx(styles.displayText)}> {item.displayName} </div> 
            </div>
          {/* <div className={cx(styles.nametext)}> {item.displayName} </div> */}
        </Table.Cell>
        <Table.Cell width={2} className={cx(styles.cell)}>
          <div className={cx(styles.text)}>
            {item.autoSync ? <i>Autosync on</i> : <i>{item.createdBy.firstName}</i>}
          </div>
          <p className={cx(styles.dateText)}>
            {item.createdDate
              ? moment.utc(item.createdDate).format('DD MMM YYYY')
              : ""} &nbsp;
            {item.createdDate
              ? moment.utc(item.createdDate).format('HH:mm')
              : ""}
          </p>
        </Table.Cell>
        <Table.Cell width={2} className={cx(styles.cell)}>
          <div className={cx(styles.text)}> {item.status} </div>
            <p className={cx(styles.dateText)}>
              {item.createdDate
                ? moment.utc(item.createdDate).format('DD MMM YYYY')
                : ""} &nbsp;
              {item.createdDate
                ? moment.utc(item.createdDate).format('HH:mm')
                : ""}
            </p>
            
        </Table.Cell>
        <Table.Cell width={2} className={cx(styles.cell)}>
          <div className={cx(styles.text)}>
            {item.newAssets !== 0 && <p className={cx(styles.subText)}>{item.newAssets} New Assets added</p>}
            {item.existingAssets !== 0 && <p className={cx(styles.subText)}>{item.existingAssets} Exisiting Assets</p>}
            {item.assetsToBeDeleted !== 0 && <p className={cx(styles.subText)}>{item.assetsToBeDeleted} Asset deleted</p>}
          </div>
        </Table.Cell>
      </Table.Row>
    </>;
  }

  return (

    <>
      <Container>
        <InfiniteScroll
          loading={loading}
          currentPage={currentPage}
          totalPages={totalPages}
          pagination={true}
          setPage={setPage}
        >
          <Table singleLine className={cx(styles.table)}>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell width={3} className={cx(styles.header)}>
                  Datasource
                </Table.HeaderCell>
                <Table.HeaderCell width={2} className={cx(styles.header)}>
                  Requested
                </Table.HeaderCell>
                <Table.HeaderCell width={2} className={cx(styles.header)}>
                  Status
                </Table.HeaderCell>
                <Table.HeaderCell width={3} className={cx(styles.header)}>
                  Result
                </Table.HeaderCell>
              </Table.Row>

            </Table.Header>
            <Table.Body className={cx(styles.body)}>
              {!loading && items && items.length === 0 && noDataMessage()}
              {loading && items && items.length === 0 && loadingMessage()}
              {items && items.length !== 0 && renderTransactions()}
            </Table.Body>
          </Table>

        </InfiniteScroll>
      </Container>
    </>

  );
};
